import Vue from 'vue'
import Vuex from 'vuex'

import settings from './settings'

import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'
var ls = new SecureLS({ isCompression: false })

const cookieSalt = 'dfljkG=2)h3v!gw3*%oe%@6&&'

import breadcrumb from './breadcrumb'
import user from './user'
import accounttype from './account-type'
import account from './account'
import detail from './detail'
import dashboard from './dashboard'
import network from './network'
import post from './post'
import post_ocr_logo from './post-ocr-logo'
import storie from './stories'
import category from './category'
import comment from './comment'
import analysis from './analysis'
import image from './image'
import evolution from './evolution'
import account_group from './account-group'
import interaction from './interaction'
import activity from './activity'
import exxport from './export'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		breadcrumb,
		user,
		account,
		post,
		post_ocr_logo,
		storie,
		accounttype,
		dashboard,
		detail,
		settings,
		network,
		category,
		comment,
		analysis,
		evolution,
		interaction,
		image,
		activity,
		account_group,
		exxport,
	},
	state: {},
	mutations: {},
	actions: {},
	plugins: [
		createPersistedState({
			storage: {
				getItem: key => ls.get(cookieSalt + key),
				setItem: (key, value) => ls.set(cookieSalt + key, value),
				removeItem: key => ls.remove(cookieSalt + key),
			},
			// persisted state pathds {user.token}
			paths: ['user.token', 'user.user', 'user.refresh'],
		}),
	],
})
